import React from "react";
import { ChartsSetWrapper, LogoLoader } from "../../../components";

const raMetrics = ["Positives", "Jobs On Hold", "Agreement Done", "Placed", "Jobs Closed"];
const bdmMetrics = ["Positives", "Agreement Done", "Internal Submission", "client Submission", "Interview Scheduled", "Joined", "Backout"];
const recruiterMetrics = ["Active Jobs", "Internal Submissions", "Client Submissions", "Interview Scheduled", "Closed Jobs", "Joined"];

const JobReports = ({
  activeButton,
  metrics,
  teamMetrics,
  roleType,
  loading
}) => {
  const reportValues = roleType === 2 
  ? [metrics?.positives || 0, metrics?.jobsOnHold || 0, metrics?.agreementDone || 0, metrics?.placed || 0, metrics?.jobsClosed || 0]
  : roleType === 3
  ? [metrics?.positives || 0, metrics?.agreementDone || 0, metrics?.internalSubmission || 0, metrics?.clientSubmission || 0, metrics?.interviewScheduled || 0, metrics?.joined || 0, metrics?.backout || 0]
  : roleType === 4
  ? [metrics?.activeJobs || 0, metrics?.internalSubmissions || 0, metrics?.clientSubmissions || 0, metrics?.interviewScheduled || 0, metrics?.closedJobs || 0, metrics?.joined || 0]
  : []

  const teamReportValues = roleType === 2 
  ? [teamMetrics?.positives || 0, teamMetrics?.jobsOnHold || 0, teamMetrics?.agreementDone || 0, teamMetrics?.placed || 0, teamMetrics?.jobsClosed || 0]
  : roleType === 3
  ? [teamMetrics?.positives || 0, teamMetrics?.agreementDone || 0, teamMetrics?.internalSubmission || 0, teamMetrics?.clientSubmission || 0, teamMetrics?.interviewScheduled || 0, teamMetrics?.joined || 0, teamMetrics?.backout || 0]
  : roleType === 4
  ? [teamMetrics?.activeJobs || 0, teamMetrics?.internalSubmissions || 0, teamMetrics?.clientSubmissions || 0, teamMetrics?.interviewScheduled || 0, teamMetrics?.closedJobs || 0, teamMetrics?.joined || 0]
  : []

  const jobReportDetails = activeButton === "myPerformance" ? reportValues : teamReportValues;

  const shouldShowLoader =
    loading &&
    (
      (activeButton === "myPerformance" && !metrics) ||
      (activeButton === "myTeamPerformance" && !teamMetrics)
    );

  if (shouldShowLoader) {
    return (
      <div className="flex justify-center items-center">
        <LogoLoader />
      </div>
    );
  }

  return (
    <div>
      <ChartsSetWrapper
        title="Job Report"
        type="donut"
        series={jobReportDetails}
        categories={roleType === 2 ? raMetrics : roleType === 3 ? bdmMetrics : roleType === 4 ? recruiterMetrics : []}
        options={{
          legend: {
            show: false,
          },
          pie: {
            infoSection: {
              show: true,
              side: "auto",
              width: 220,
              height: 130,
              total: false,
            },
          },
        }}
      />
    </div>
  );
};

export default JobReports;
